<template>
  <div>
    <applications-table striped hover></applications-table>
  </div>
</template>

<script>
import ApplicationsTable from './ApplicationsTable'

export default {
  name: 'applications',
  mounted () {
    this.$store.dispatch('fetchImplementationsList').then(() => {
      
    })
  },
  components: {
      ApplicationsTable
  }
}
</script>
